module.exports = __webpack_public_path__ + "static/media/image-beginners@2x.d3159e93.png";